import { useState } from 'react';
import SectionHeading from '@/pages/home/components/SectionHeading';
import useScrollReveal from '@/hooks/useScrollReveal';
import { homeFaqItems } from '@/mocks/home';

export default function FaqSection() {
  const [openId, setOpenId] = useState<string>(homeFaqItems[0].id);
  const { ref, visible } = useScrollReveal();

  return (
    <section id="faq" className="w-full bg-background-100 py-16 md:py-24 scroll-mt-24">
      <div ref={ref} className={`w-full px-4 md:px-8 nh-reveal ${visible ? 'nh-in' : ''}`}>
        <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,380px)_minmax(0,1fr)] gap-8 lg:gap-14">
          <div className="lg:sticky lg:top-28 lg:self-start">
            <SectionHeading
              kicker="常见问题"
              title="先把「怎么判断」说清楚"
              desc="关于实锤、原视频、录屏和原始截图，被问得最多的几个问题都放在这里。"
            />
            <div className="mt-8 rounded-lg bg-background-50 border border-background-200 p-6">
              <span className="flex w-11 h-11 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className="ri-question-answer-line text-xl"></i>
              </span>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600">
                没有找到答案？可以在页面底部提交你的疑问，我们会补充到这份说明里。
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            {homeFaqItems.map((item) => {
              const open = item.id === openId;
              return (
                <div
                  key={item.id}
                  className={`rounded-lg border transition-colors ${
                    open ? 'bg-background-50 border-primary-300' : 'bg-background-50 border-background-200'
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenId(open ? '' : item.id)}
                    className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-5 text-left cursor-pointer"
                  >
                    <span className="font-heading text-base md:text-lg font-bold text-foreground-950">{item.question}</span>
                    <span
                      className={`shrink-0 w-8 h-8 flex items-center justify-center rounded-full transition-colors ${
                        open ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'
                      }`}
                    >
                      <i className={open ? 'ri-subtract-line text-lg' : 'ri-add-line text-lg'}></i>
                    </span>
                  </button>
                  {open && (
                    <div className="px-5 md:px-6 pb-6 -mt-1">
                      <p className="text-sm leading-relaxed text-foreground-600">{item.answer}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}